import ReactDOM from 'react-dom/client';
import './index.css';

/**
 * Conditional entry point based on build mode.
 * WHY: Widget/iframe builds must NOT bundle @verif-y/sso-library (~56KB, uses eval).
 * Vite replaces import.meta.env.VITE_APP_MODE at build time, so Rollup
 * tree-shakes the unused branch entirely — the dead import is never included.
 */
const mode = import.meta.env.VITE_APP_MODE;
const root = ReactDOM.createRoot(document.getElementById('root')!);

if (mode === 'widget' || mode === 'iframe') {
  import('./WidgetApp').then(({ default: WidgetApp }) => {
    root.render(<WidgetApp />);
  });
} else {
  import('./App').then(({ default: App }) => {
    root.render(<App />);
  });
}
